export default "__VITE_ASSET__Dl2OWbFc__"